/**
 * This file contains shared proptypes for common objects used throughout the app
 * in order to not have to repeat them in many different places.
 */

import PropTypes from "prop-types";

export const contactPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  phone: PropTypes.string,
  email: PropTypes.string,
  type: PropTypes.number.isRequired,
  isIBO: PropTypes.bool,
  pinLevel: PropTypes.oneOf([1, 2, 3, 4, null]),
  vcs: PropTypes.shape({
    monthly: PropTypes.array,
    kpi: PropTypes.shape({
      vcs: PropTypes.shape({
        current: PropTypes.number,
        previous: PropTypes.number,
        change: PropTypes.number,
      }),
      buyers: PropTypes.shape({
        current: PropTypes.number,
        previous: PropTypes.number,
        change: PropTypes.number,
      }),
      fiscal: PropTypes.shape({
        current: PropTypes.number,
        previous: PropTypes.number,
        change: PropTypes.number,
      }),
    }),
  }),
});

export const samplePropType = PropTypes.shape({
  /**
   * Tracked sample record ID.
   */
  id: PropTypes.number,

  /**
   * List of tag strings.
   */
  tags: PropTypes.arrayOf(PropTypes.string),

  /**
   * Whether the customer liked the product or not.
   */
  liked: PropTypes.bool,

  /**
   * Date the sample was given.
   */
  date: PropTypes.oneOfType([Date, PropTypes.string]),

  /**
   * User notes field.
   */
  notes: PropTypes.string,
});
